import { ObjectFieldsChecker } from "../../../../../tools/ObjectFieldsChecker";
import { ShopItemDto } from "../../../../networking/data/responses/shop/ShopItemDto";
import { ShopItemCurrencyType } from "./ShopItemCurrencyType";

export class ShopItem {
    public readonly price: number;
    public readonly currency: ShopItemCurrencyType;
    public readonly tokenId: string;
    public readonly id: string;
    public readonly storeItemId: string;
    public readonly flags: {
        isBestValue: boolean,
        isPopular: boolean
    };
    public readonly reward: { diceRolls: number };
    public readonly valueForOffLabel?: number;

    public constructor(shopItemDto: ShopItemDto) {
        ObjectFieldsChecker.throwIfInvalidFields(shopItemDto, [
            "price",
            "currency",
            "tokenId",
            "id",
            "storeItemId",
            "flags",
            "reward"
        ]);
        this.price = shopItemDto.price;
        this.currency = shopItemDto.currency as ShopItemCurrencyType;
        this.tokenId = shopItemDto.tokenId;
        this.id = shopItemDto.id;
        this.storeItemId = shopItemDto.storeItemId;
        this.flags = shopItemDto.flags;
        this.reward = shopItemDto.reward;
        this.valueForOffLabel = shopItemDto.valueForOffLabel;
    }
}
